import { styled as t } from "styled-components";
import { MediaQuery as e } from "../../../styles/variables.js";
import { skeletonFadeAnimation as a } from "../../../styles/animation.js";
const i = t.span`
  position: relative;

  @media ${e.SCREEN_MD_UP} {
    min-width: 240px;
  }
`, d = t.span`
  position: relative;

  button {
    @media ${e.SCREEN_MD_UP} {
      min-width: 152px;
    }
  }
`, p = t.span`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    'revealed'
    'to-take';

  @media ${e.SCREEN_MD_UP} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'revealed to-take';

    min-width: 172px;
  }
`, m = t.span`
  grid-area: to-take;
  min-width: unset;

  @media ${e.SCREEN_MD_UP} {
    min-width: 152px;
    max-width: 328px;
  }
`, l = t.span`
  grid-area: revealed;
  min-width: unset;
  max-height: 40px;

  @media ${e.SCREEN_MD_UP} {
    min-width: 172px;
  }
`, s = t.div`
  ${i} {
    &:last-of-type {
      top: 8px;
    }
  }
`, u = t.div`
  width: 100%;
  height: 36px;
  border-radius: 18px;
  ${a}
`;
export {
  i as DealButtonContainer,
  l as DealButtonRevealedContainer,
  u as DealButtonSkeleton,
  m as DealButtonToTakeContainer,
  d as DealButtonWrapper,
  s as DealDoubleButtonContainer,
  p as DealDoubleButtonContainerSideBySyde
};
